import React from 'react';
import styled from 'styled-components';
import Button from '@material-ui/core/ButtonBase';

const PaginationButton = styled( Button )`
    width: 3em;
    min-width: 50px;
    max-width: 72px;
    border: 1px solid ${props => props.theme.palette.blueGrey[200]};
    margin-left: -1px;
`;

export default PaginationButton;



// WEBPACK FOOTER //
// ./src/components/styles/PaginationButton.js